export function setupTabs(): void {
    const tabs = ["map", "progress"];

    tabs.forEach((tab) => {
        document.getElementById(`nav-${tab}`).onclick = () => {
            tabs.filter((t) => t !== tab).forEach((t) => {
                document.getElementById(`panel-${t}`).style.display = "none";
            });
            document.getElementById(`panel-${tab}`).style.display = "flex";
        };
    });
}
